import React from "react";
import "./StyledSegmented.css";

export default function StyledSegmented({
  options = [],
  className = "",
  value,
  onChange,
}) {
  return (
    <div className={`StyledSegmented ${className}`}>
      {options.map((option) => (
        <div
          key={option.value}
          className={`StyledSegmented-tab${value === option.value ? " selected" : ""}`}
          onClick={() => onChange(option.value === value ? "" : option.value)}
        >
          {option.label}
        </div>
      ))}
    </div>
  );
}
